<template>
  <div class="form-row">
    <h6 class="sub-frm-title">Download Events Report</h6>
    <div class="col-sm-12">
      <b-card class="report-card">
        <div class="report-grid">
          <div class="report-grid__row">
            <div class="report-field">
              <label class="report-label">Training Type</label>
              <selectize
                id="select-training-type"
                v-model="selectedTrainingType"
                @input="fetchTrainingsByType"
                :searchable="true"
                :settings="typeSettings"
              >
                <option
                  v-for="(item, index) in trainingTypeList"
                  :key="index"
                  :value="item.id"
                >
                  {{ item.title }}
                </option>
              </selectize>
            </div>
          </div>
          <div class="report-grid__row">
            <div class="report-field">
              <label class="report-label">Select Event</label>
              <multiselect
                v-model="selectedTrainings"
                :options="trainingListArr"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                track-by="id"
                :custom-label="option => option.title"
                placeholder="Search or Select Event"
              >
                <template #option="props">
                  <div class="option-custom">
                    <strong>{{ props.option.title }}</strong>
                    <div class="option-custom__date">
                      {{ formatDate3(props.option.startdate) }} to
                      {{ formatDate3(props.option.enddate) }}
                    </div>
                    <div class="option-custom__venue">{{ props.option.venue }}</div>
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
          <div class="report-grid__row report-grid__row--actions">
            <b-button
              class="download-btn"
              variant="primary"
              @click="getReport"
              :disabled="selectedTrainings.length === 0"
            >
              Download Sheet
            </b-button>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Selectize from "vue2-selectize";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { downloadTrainingReport} from '../../utils/DownloadReport';
import { formatDate3 } from "@/utils/DateFormate";


export default {
    data: () => ({
        trainingTypeList: [],
        selectedTrainingType: null,
        trainingListArr: [],
        selectedTrainings: [],
        trainingReport: [],
        training_code: null,
        userId: '',
        userRole: '',
      typeSettings: {
        maxItems: 1,
        plugins: ["remove_button"],
        placeholder: "Select Events Type"
      }
    }),
    mounted() {
        this.userId = JSON.parse(localStorage.getItem("currentUser")).id
        this.userRole = JSON.parse(localStorage.getItem("currentUser")).role_id
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')

        this.fetchTrainingTypes();
   
    },
    components: {
        Multiselect,
        Selectize
    },
    methods: {
        formatDate3,
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        getReport(){
            this.openLoading();
            setTimeout(() => {
                this.closeLoading();
            }, 2000);
           const trainingIds = this.selectedTrainings.map(item => item.id);
           downloadTrainingReport(trainingIds)
        },
        fetchTrainingTypes() {
           axios
             .get(process.env.VUE_APP_BASE_PATH + "/trainingtype/get")
             .then((response) => {
               this.trainingTypeList = response.data;
             })
             .catch(() => {
               this.$toasted.global.errorMsg("Failed to load training types");
             });
         },
         fetchTrainingsByType() {
      if (!this.selectedTrainingType) return;

      let url = `${process.env.VUE_APP_BASE_PATH}/trainings/get/all?trainingTypeId=${this.selectedTrainingType}`;

      if (this.userRole === 2) {
        url += `&user_id=${this.userId}`;
      } else if (this.userRole === 3) {
        url += `&po_id=${this.userId}`;
      }

      this.openLoading();
      axios
        .get(url)
        .then((res) => {
          this.trainingListArr = res.data;
          this.selectedTrainings = []; // clear selection
        })
        .catch(() => {
          this.$toasted.global.errorMsg("Failed to load trainings");
        })
        .finally(() => this.closeLoading());
    },
       

    },
};
</script>

<style scoped>
.report-card {
  border-radius: 12px;
  padding: 2rem;
  border: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(180deg, #ffffff, #fdfdfd);
  box-shadow: 0 10px 35px rgba(0, 0, 0, 0.08);
}
.report-grid {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
}
.report-grid__row--actions {
  display: flex;
  justify-content: flex-end;
}
.report-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.report-label {
  font-weight: 600;
  color: #4267b2;
  letter-spacing: 0.02em;
}
.download-btn {
  padding: 0.75rem 2rem;
  border-radius: 999px;
  font-weight: 600;
  color: #fff;
}
.option-custom {
  padding: 4px 8px;
  line-height: 1.1;
}
.option-custom strong {
  font-weight: 600;
  display: block;
}
.option-custom__date,
.option-custom__venue {
  font-size: 0.85rem;
  color: #3a3a3a;
  line-height: 1.2;
}
.option-custom__date {
  margin-top: 2px;
}
.option-custom__venue {
  margin-top: 1px;
}

.multiselect__option--highlight .option-custom,
.multiselect__option--highlight .option-custom strong,
.multiselect__option--highlight .option-custom__date,
.multiselect__option--highlight .option-custom__venue {
  color: #fff;
}

@media (max-width: 768px) {
  .report-card {
    padding: 1.25rem;
  }
  .report-grid__row--actions {
    justify-content: center;
  }
}
</style>
